__turbopack_context__.v({
  "faq": "faq-module-scss-module__efF60G__faq",
  "faqAccordion": "faq-module-scss-module__efF60G__faqAccordion",
  "faqTitle": "faq-module-scss-module__efF60G__faqTitle",
});
